
import React from "react";
import CtaButton from "@/components/CtaButton";
import { MagicLetterBoxLink } from "@/components/funnel/MagicLetterBoxLink";

const MagicJourneySection = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="section-title">
          Choose Your <span className="text-elfGreen-ink">Magical Journey</span>
        </h2>
        <p className="section-subtitle mb-12">
          Start with free resources and three personalized PDF deliveries per email address on Elf Letter Bot, then keep the tradition going with The Magic Letter Box.
        </p>
        
        <div className="max-w-4xl mx-auto grid gap-6 md:grid-cols-2">
          <div className="bg-white p-8 rounded-2xl shadow-lg">
            <h3 className="text-2xl font-bold mb-4 text-elfGreen-ink">Start free here</h3>
            <p className="mb-6">
              Use the Elf Letter Bot tools and receive three personalized PDF letters per email address at no charge.
            </p>
            <CtaButton
              text="Try the free generator"
              href="/elf-letter-generator?utm_source=home&utm_medium=journey&utm_campaign=free-generator"
              variant="secondary"
              className="w-full"
            />
          </div>
          <div className="bg-elfPink-light p-8 rounded-2xl shadow-lg">
            <h3 className="text-2xl font-bold mb-4 text-elfRed-ink">Keep going with Family</h3>
            <p className="mb-6">
              The Magic Letter Box starts with a five-letter parent trial. Family is $15/year for unlimited letters, premium templates, up to six children, saved history, and email delivery.
            </p>
            <MagicLetterBoxLink
              source="magic-journey"
              campaign="family-membership"
              className="inline-block w-full rounded-xl bg-elfRed-ink px-6 py-3 text-center font-semibold text-white shadow-md transition-colors duration-300 hover:bg-[#892638] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-700"
            >
              Explore Family membership
            </MagicLetterBoxLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MagicJourneySection;
